import DeliveryTypeForm from './DeliveryTypeForm'

export default DeliveryTypeForm
